import * as React from 'react';
import SpamOptionIconBar from '../components/SpamOptionIconBar';
import SpamOptionTextField from './SpamOptionTextField';
import { SpamScenarioId } from 'owa-junkmail-configuration';
import { ControlIcons } from 'owa-control-icons';
import { deleteFromSpamList } from '../actions/spamListMutatorActions';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react';
import { setSpamListIndexToEdit } from '../actions/spamNewItemMutatorActions';

const styles = require('./SpamOptionFull.scss');

export interface SpamOptionRowProps {
    index: number;
    isEditMode: boolean;
    placeHolder: string;
    rowTextValue: string;
    scenarioId: SpamScenarioId;
}

@observer
export default class SpamOptionRow extends React.Component<SpamOptionRowProps, {}> {
    render() {
        const { index, isEditMode, placeHolder, rowTextValue, scenarioId } = this.props;
        const containerClass = isEditMode
            ? styles.newSpamOptionRowContainer
            : styles.existingSpamOptionRowContainer;
        return (
            <div className={containerClass}>
                {isEditMode ? (
                    <SpamOptionTextField
                        key="SpamOptionTextField"
                        index={index}
                        isEditMode={isEditMode}
                        scenarioId={scenarioId}
                        placeHolder={placeHolder}
                        rowTextValue={rowTextValue}
                    />
                ) : (
                    <>
                        <span className={styles.existingSpamOptionRowText}>{rowTextValue}</span>
                        {this.getButtons()}
                    </>
                )}
            </div>
        );
    }

    private getButtons = (): JSX.Element => {
        const editButton = (
            <IconButton
                key="edit"
                iconProps={{ iconName: ControlIcons.Edit }}
                onClick={this.editButtonClicked}
            />
        );
        const deleteButton = (
            <IconButton
                key="delete"
                iconProps={{ iconName: ControlIcons.Delete }}
                onClick={this.deleteButtonClicked}
            />
        );
        return <SpamOptionIconBar iconButtons={[editButton, deleteButton]} />;
    };

    private editButtonClicked = (): void => {
        setSpamListIndexToEdit(this.props.scenarioId, this.props.index);
    };

    private deleteButtonClicked = (): void => {
        deleteFromSpamList(this.props.scenarioId, this.props.index);
    };
}
